// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"PageTitle_pageTitle___DbBV","title":"PageTitle_title__er4eZ","eyebrow":"PageTitle_eyebrow__p3e3L","titleScribble":"PageTitle_titleScribble__rdzT6"};